"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChileAdditionalPlanParser = void 0;
var _constants = require("../../constants");
var _AdditionalPlanParser = require("../generic/AdditionalPlanParser");
class ChileAdditionalPlanParser extends _AdditionalPlanParser.AdditionalPlanParser {
  constructor(plan, numberOfPlans, maximumAdditionalPlans) {
    super(plan, numberOfPlans, maximumAdditionalPlans);
  }
  showAdditionalPlanData(props) {
    var _metadata$flags, _metadata$flags2, _metadata$flags3, _metadata$flags4;
    const {
      metadata,
      isCustomer
    } = props;
    return !isCustomer && !(metadata !== null && metadata !== void 0 && (_metadata$flags = metadata.flags) !== null && _metadata$flags !== void 0 && _metadata$flags[_constants.FLAGS.ADDITIONAL_PLAN]) || (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags2 = metadata.flags) === null || _metadata$flags2 === void 0 ? void 0 : _metadata$flags2[_constants.FLAGS.NEW_CUSTOMER]) && (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags3 = metadata.flags) === null || _metadata$flags3 === void 0 ? void 0 : _metadata$flags3[_constants.FLAGS.BOTH_FLOW]) && (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags4 = metadata.flags) === null || _metadata$flags4 === void 0 ? void 0 : _metadata$flags4[_constants.FLAGS.NEXT_FLOW]);
  }
}
exports.ChileAdditionalPlanParser = ChileAdditionalPlanParser;